import Loadable from 'react-loadable';

import { Loading } from '../../common/navigation';

const DocusignPK2K12 = Loadable({
  loader: () => import('./components/docusignPK2K12'),
  loading: Loading,
});

export const routes = [
  {
    path: '/docusignPK2K12',
    exact: true,
    name: 'docusignPK2K12',
    component: DocusignPK2K12,
  },
];
